function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
export { _assertThisInitialized as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
// module id = ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
// module chunks = vendor